module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isManager('project|maintenance|finance|management|admin')) ? _c('popup', {
    attrs: {
      "button-style": "primary",
      "heading": "New Sharer",
      "show-text": _vm.showText,
      "button-text": "Sharer",
      "size": "medium",
      "button-icon": "fa fa-plus",
      "disable-button": !_vm.isManager('project|finance') || _vm.readOnly
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('div', {
    staticClass: "padded",
    staticStyle: {
      "clear": "both",
      "text-align": "left"
    }
  }, [_c('el-row', {
    attrs: {
      "justify": "start",
      "align": "middle"
    }
  }, [_c('el-form', {
    ref: "licenseeForm",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.telco),
      callback: function($$v) {
        _vm.telco = $$v
      },
      expression: "telco"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('select-sharer', {
    attrs: {
      "size": _vm.size,
      "placeholder": "Select Sharer",
      "requried": ""
    },
    model: {
      value: (_vm.telco.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.telco, "organisation_id", $$v)
      },
      expression: "telco.organisation_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Their Site ID",
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.telcoSiteId),
      callback: function($$v) {
        _vm.$set(_vm.telco, "telcoSiteId", $$v)
      },
      expression: "telco.telcoSiteId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('select-service-type', {
    attrs: {
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.telco, "serviceType", $$v)
      },
      expression: "telco.serviceType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('select-spectrum', {
    attrs: {
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.spectrumBand),
      callback: function($$v) {
        _vm.$set(_vm.telco, "spectrumBand", $$v)
      },
      expression: "telco.spectrumBand"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Handover Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.handover),
      callback: function($$v) {
        _vm.$set(_vm.telco, "handover", $$v)
      },
      expression: "telco.handover"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Commencement Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.started),
      callback: function($$v) {
        _vm.$set(_vm.telco, "started", $$v)
      },
      expression: "telco.started"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "On Air Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.onAir),
      callback: function($$v) {
        _vm.$set(_vm.telco, "onAir", $$v)
      },
      expression: "telco.onAir"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Expiry Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.format,
      "size": _vm.size,
      "label": "Contract End",
      "disabled": ""
    },
    model: {
      value: (_vm.expiryDate),
      callback: function($$v) {
        _vm.expiryDate = $$v
      },
      expression: "expiryDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tenor (years)"
    }
  }, [_c('el-slider', {
    attrs: {
      "size": _vm.size,
      "min": 1,
      "max": 20,
      "show-stops": "",
      "show-input": ""
    },
    model: {
      value: (_vm.tenor),
      callback: function($$v) {
        _vm.tenor = $$v
      },
      expression: "tenor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6,
      "offset": 2
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Cabins",
      "size": _vm.size,
      "min": 0,
      "max": 10
    },
    model: {
      value: (_vm.telco.cabin),
      callback: function($$v) {
        _vm.$set(_vm.telco, "cabin", $$v)
      },
      expression: "telco.cabin"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('check-box', {
    attrs: {
      "label": 'Own ' + _vm.utilLabel + ' Meter'
    },
    model: {
      value: (_vm.telco.ownMeter),
      callback: function($$v) {
        _vm.$set(_vm.telco, "ownMeter", $$v)
      },
      expression: "telco.ownMeter"
    }
  })], 1)], 1), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 4
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Sharer Specific CAPEX",
      "placeholder": "CAPEX",
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.capex),
      callback: function($$v) {
        _vm.$set(_vm.telco, "capex", $$v)
      },
      expression: "telco.capex"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 4
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Sharer Specific OPEX",
      "placeholder": "OPEX",
      "size": _vm.size
    },
    model: {
      value: (_vm.telco.opex),
      callback: function($$v) {
        _vm.$set(_vm.telco, "opex", $$v)
      },
      expression: "telco.opex"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7d10d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/SharerAction.vue
// module id = 1473
// module chunks = 0